var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rating-meter" }, [
    _c("div", { staticClass: "rating-body" }, [
      _c("div", {
        directives: [
          {
            name: "fillable",
            rawName: "v-fillable.fill",
            value: { val: _vm.meterVal },
            expression: "{ val: meterVal }",
            modifiers: { fill: true },
          },
        ],
        staticClass: "rating-fill",
      }),
      _vm._v(" "),
      _c("div", { staticClass: "rating-cover" }, [
        _c("img", {
          directives: [
            {
              name: "fillable",
              rawName: "v-fillable.cover",
              value: { val: _vm.meterVal },
              expression: "{ val: meterVal }",
              modifiers: { cover: true },
            },
          ],
          staticClass: "needle",
          attrs: {
            src:
              (_vm.CFG_WIDGET_URL_BASE || "") +
              "/static-assets/images/cssimages/needle.png",
            alt: "Needle",
          },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }